<template>
  <svg :width="props.size" :height="props.size" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="display:block;flex-shrink:0;">
    <path
      opacity="0.4"
      d="M17.1834 7.04183C16.3084 3.19183 12.9501 1.4585 10.0001 1.4585C10.0001 1.4585 10.0001 1.4585 9.99175 1.4585C7.05008 1.4585 3.68341 3.1835 2.80841 7.0335C1.83341 11.3335 4.46675 14.9752 6.85008 17.2668C7.73341 18.1168 8.86675 18.5418 10.0001 18.5418C11.1334 18.5418 12.2667 18.1168 13.1417 17.2668C15.5251 14.9752 18.1584 11.3418 17.1834 7.04183Z"
      :fill="props.primaryColor"
    />
    <path
      d="M10 11.2168C11.4497 11.2168 12.625 10.0415 12.625 8.5918C12.625 7.14205 11.4497 5.9668 10 5.9668C8.55025 5.9668 7.375 7.14205 7.375 8.5918C7.375 10.0415 8.55025 11.2168 10 11.2168Z"
      :fill="props.primaryColor"
    />
  </svg>
</template>

<script setup>
/* global defineProps */
const props = defineProps({
  primaryColor: {
    type: String,
    default: '#3C67D6'
  },
  size: {
    type: [Number, String],
    default: 20
  }
})

</script>
